export default __webpack_public_path__ + "static/media/content-deco-6.713c9fad.webp";